import { render, staticRenderFns } from "./AccountOrder.vue?vue&type=template&id=740d5bfa"
import script from "./AccountOrder.vue?vue&type=script&lang=ts"
export * from "./AccountOrder.vue?vue&type=script&lang=ts"
import style0 from "./AccountOrder.vue?vue&type=style&index=0&id=740d5bfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports